import { MAX_DATE_VALUE, MIN_DATE_VALUE } from "../constants";
import { IExtendableDto } from "../dto";
import { DatesUnit, ITypeormWhereCriteria, RydeUiUnit } from "../models";
import { isRideEntity } from "./common.helpers";

export interface ITypeormBetweenCriteria {
  $between: string[];
}

const calendarDatesToCriteria = (
  calendarDates: DatesUnit,
): ITypeormBetweenCriteria => {
  const criteria: ITypeormBetweenCriteria = {
    $between: [
      calendarDates?.date1 || MIN_DATE_VALUE,
      calendarDates?.date2 || MAX_DATE_VALUE,
    ],
  };
  return criteria;
};

export const buildTypeOrmCalendarDatesCriteria = (
  entity: RydeUiUnit,
  calendarDates?: DatesUnit,
): ITypeormWhereCriteria<IExtendableDto> => {
  const query: ITypeormWhereCriteria<IExtendableDto> = {};

  if (calendarDates) {
    const dateValue = calendarDatesToCriteria(calendarDates);

    if (isRideEntity(entity)) {
      query.rideStart = dateValue;
    } else if (entity === "booking") {
      query.bookTime = dateValue;
    } else {
      query.createdAt = dateValue;
    }
  }

  return query;
};
